// eslint-disable-next-line import/no-extraneous-dependencies
import {createBrowserHistory} from "history"

export default createBrowserHistory()
